import styled from 'styled-components';
import { ModalBody } from 'react-bootstrap';

export const CustomModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 15px;
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.02) 0%, rgba(244, 241, 222, 0.05) 100%);
  border-radius: 0 0 12px 12px;
`;

export const CustomFormGroup = styled.div`
  margin-bottom: 15px;
`;

export const CustomLabel = styled.label`
  color: #1a1a2e;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

export const CustomFormControl = styled.input`
  border: 1px solid rgba(26, 26, 46, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.9);
  color: #1a1a2e;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  width: 100%;

  &:focus {
    border-color: rgba(26, 26, 46, 0.4);
    box-shadow: 0 0 0 0.2rem rgba(26, 26, 46, 0.1);
    background: rgba(255, 255, 255, 0.95);
    outline: none;
  }

  &::placeholder {
    color: rgba(26, 26, 46, 0.5);
  }

  &.is-invalid {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.1);
  }
`;

export const CustomSelect = styled.select`
  border: 1px solid rgba(26, 26, 46, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.9);
  color: #1a1a2e;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  width: 100%;

  &:focus {
    border-color: rgba(26, 26, 46, 0.4);
    box-shadow: 0 0 0 0.2rem rgba(26, 26, 46, 0.1);
    background: rgba(255, 255, 255, 0.95);
    outline: none;
  }

  &.is-invalid {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.1);
  }
`;

export const CustomTextArea = styled.textarea`
  border: 1px solid rgba(26, 26, 46, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.9);
  color: #1a1a2e;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  width: 100%;
  resize: vertical;
  min-height: 80px;

  &:focus {
    border-color: rgba(26, 26, 46, 0.4);
    box-shadow: 0 0 0 0.2rem rgba(26, 26, 46, 0.1);
    background: rgba(255, 255, 255, 0.95);
    outline: none;
  }

  &::placeholder {
    color: rgba(26, 26, 46, 0.5);
  }

  &.is-invalid {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.1);
  }
`;

export const CustomFeedback = styled.div`
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
`;

export const CustomButton = styled.button`
  border: 1px solid #1a1a2e;
  color: #1a1a2e;
  background: transparent;
  font-weight: 600;
  border-radius: 8px;
  padding: 12px 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 120px;

  &:hover {
    background: #1a1a2e;
    color: #f4f1de;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(26, 26, 46, 0.15);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const CustomButtonSecondary = styled(CustomButton)`
  background: rgba(108, 117, 125, 0.1);
  border-color: rgba(108, 117, 125, 0.3);
  color: #6c757d;

  &:hover {
    background: #6c757d;
    color: white;
    border-color: #6c757d;
  }
`;
